<template>
    <div class="container">
        <el-row class="header" type="flex" justify="center">
            <el-col class="header-content" :span="24">
                <Header ref="header"></Header>
            </el-col>
        </el-row>
        <el-row class="content" type="flex" justify="center">
            <el-col class="content-nav" style>
                <Nav ref="nav"></Nav>
            </el-col>
            <el-col class="content-content" style="overflow: auto;">
                <Bread :data="this.$router.history.current.meta.record"></Bread>
                <keep-alive>
                    <router-view v-if="$route.meta.keepAlive" />
                </keep-alive>
                <router-view @defaultPath="defaultPath" @load="load" @getNoticeMessage="getNoticeMessage" ref="view" v-if="!$route.meta.keepAlive" />
                <Footer></Footer>
            </el-col>
        </el-row>
        <!-- <el-row class="footer" type="flex" justify="center">
            <el-col class="footer-content">

            </el-col>
        </el-row> -->
        <div class="onebox">
            <el-dialog
                title="温馨提示"
                :visible.sync="isShowNotice"
                width="22%"
                left
            >
                <div class="onebox-in">
                    {{noticeMessage.notice}}
                </div>
                <span slot="footer" class="dialog-footer contactFooter">
                <el-button type="primary" @click="isShowNotice = false">知道了</el-button>
                </span>
            </el-dialog>
        </div>
        <div class="onebox">
            <el-dialog
                title="温馨提示"
                :visible.sync="isShowUpdate"
                width="22%"
                left
            >
                <div class="onebox-in">
                    {{noticeMessage.update}}
                </div>
                <el-progress v-if="isProgress" :text-inside="true" :stroke-width="20" :percentage="progress"></el-progress>
                <span slot="footer" class="dialog-footer contactFooter">
                <el-button v-if="isUpdate" :disabled="isProgress" type="primary" @click="Update">更新升级</el-button>
                <el-button v-else type="primary" @click="isShowUpdate = false">完成</el-button>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
    import Header from "@/components/public/Header";
    import Footer from "@/components/public/Footer";
    import Nav from "@/components/public/Nav";
    import Bread from "@/components/Bread";
    import GetUserMsg from "@/api/PublicModule";
    import Login from "@/api/Login"
    export default {
        data() {
            return{
                isShowNotice:false,
                isShowUpdate:false,
                noticeMessage:{},
                isProgress:false,
                progress:0,
                isUpdate:true
            }
        },
        components: {
            Header,
            Footer,
            Nav,
            Bread
        },
        computed: {
            // defaultActive: function () {
            //     return this.$route.path.replace("/", "");
            // }
        },
        methods: {
            getUserMsgDetail(i) { //获取该账号的信息
                GetUserMsg.getUserMsg()
                    .then((res) => {
                        localStorage.setItem('account', JSON.stringify(res.data.data))
                        this.$refs.header.account();
                        this.$refs.nav.account();
                        if(i!==1){
                            this.$refs.view.account();
                        }
                    }).catch((err) => {
                        console.log(err)
                    });
            },
            load(i) {
                this.getUserMsgDetail(i);
            },
            // 刷新路由
            defaultPath(path){
                this.$refs.nav.account(path);
            },
            getNoticeMessage(){
                var that = this;
                Login.getNotice(this.loginForm)
                .then((res) => {
                    let {notice,update} = res.data.data;
                    if(notice.length){
                        that.isShowNotice = true;
                        that.noticeMessage['notice']=notice[notice.length-1].content;
                    }
                    if(update.length){
                        that.isShowUpdate = true;
                        that.noticeMessage['update']=update[update.length-1].content;
                    }
                }).catch((err) => {
                    console.log(err)
                });
            },
            Update(){
                this.isProgress = true;
                 var T = setInterval(() => {
                    this.progress+=20;
                    if (this.progress == 100) {
                        clearInterval(T);
                        this.isProgress = false;
                        this.isUpdate = false;
                    }
                }, 1000);
            }
        },
        mounted() {
            this.getUserMsgDetail();
        }
    };
</script>
<style scoped>
    .container {
        padding: 0;
        margin: 0;
    }

    /* HEADER */
    .header {
        position: absolute;
        width: 100%;
        height: 50px;
        left: 0;
        top: 0;
        background: #003068;
    }

    .header-content {
        max-width: 1280px;
        min-width: 1280px;
        height: 50px;
    }

    /* CONTENT */
    .content {
        position: absolute;
        max-width: 1280px;
        min-width: 1280px;
        width: 1280px;
        left: 50%;
        margin-left: -640px;
        top: 52px;
        bottom: 0;
    }

    .content .content-nav {
        position: absolute;
        max-width: 180px;
        min-width: 180px;
        border-radius: 5px;
        background: #fff;
        top: 0;
        left: 0;
        bottom: 0;
        overflow: scroll;
    }

    .content-content {
        position: absolute;
        max-width: 1080px;
        min-width: 1080px;
        margin-left: 20px;
        top: 0;
        right: 0;
        bottom: 0;
        overflow: scroll;
    }
    .onebox-in{
        min-height: 100px;
        border: 1px solid #e7e7e7;
    }
    /* FOOTER */
    /* .footer {
        width: 100%;
        height: 100px;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 100;
    }

    .footer .footer-content {
        max-width: 1280px;
        min-width: 1280px;
        display: flex;
        justify-content: center;
    } */
</style>
<style>
    .onebox .el-dialog--center {
        min-width: 453px;
    }
    .onebox .el-dialog__footer {
        padding: 20px 0;
        text-align: center;
        border-top: 1px solid #f5f6f9;
    }
</style>



// WEBPACK FOOTER //
// src/views/index.vue